const env = import.meta.env;

export const apiBaseUrl = (env.VITE_API_BASE_URL as string | undefined) ?? "/api";

/** Base for the public verification URL encoded in the certificate QR. */
export const verifyBaseUrl =
  (env.VITE_PUBLIC_VERIFY_BASE_URL as string | undefined) ??
  `${window.location.origin}/verify`;

/**
 * Guarantor block printed on the certificate.
 * Placeholder until the issuing legal entity is confirmed — see spec §7.1.
 */
export const guarantor = {
  entity: (env.VITE_CERT_GUARANTOR_ENTITY as string | undefined) || "VERSUS CONCEPT TRADING LLC",
  address:
    (env.VITE_CERT_GUARANTOR_ADDRESS as string | undefined) ||
    "Ernst-Heinkel-Ring 5-7, Hohenbrunn (Germany)",
  vat: (env.VITE_CERT_GUARANTOR_VAT as string | undefined) || "DE368740191",
  hrb: (env.VITE_CERT_GUARANTOR_HRB as string | undefined) || "HRB 292715",
};
